(() => {
  const QUICK_CART_SECTION = "quick-cart";
 
  async function refreshAndOpenCart() {
    const cartRoot = window.Shopify?.routes?.root || "/";
 
    try {
      const [sectionHtml, cart] = await Promise.all([
        fetch(`${cartRoot}cart?section_id=${QUICK_CART_SECTION}`).then((response) =>
          response.text()
        ),
        fetch(`${cartRoot}cart.js`).then((response) => response.json()),
      ]);
 
      document.dispatchEvent(
        new CustomEvent("apps:product-added-to-cart", {
          detail: {
            sections: {
              [QUICK_CART_SECTION]: sectionHtml,
            },
            cart,
          },
        })
      );
 
      document.querySelectorAll("[data-js-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
      });
 
      const cartIcon = document.querySelector("[data-js-cart-icon]");
      if (cartIcon) {
        requestAnimationFrame(() => {
          cartIcon.click();
        });
      }
    } catch (error) {
      console.error("[rebuy-bundle] Failed to refresh cart drawer", error);
    }
  }
 
  function onBundleAddedToCart() {
    refreshAndOpenCart();
  }
 
  document.addEventListener("rebuy.addBundleToCart", onBundleAddedToCart);
  document.addEventListener("rebuy:addBundleToCart", onBundleAddedToCart);
})();
 
/* ------------------------------------------------------------------ */
/* Quick View → move each Rebuy quick-view button onto its product     */
/* image so it can be revealed on hover (styled in rebuy-bundle.css).  */
/* Re-runs on Rebuy re-renders. Moving the node keeps its click        */
/* handler intact, so Quick View still opens the modal.                */
/* ------------------------------------------------------------------ */
(() => {
  function moveQuickViews() {
    // Only overlay on hover-capable (desktop) devices. On touch there is no
    // hover, so leave the button in normal flow where it's reliably tappable.
    if (!window.matchMedia("(hover: hover)").matches) return;
    document
      .querySelectorAll(".rebuy-bundle-builder__product-quick-view")
      .forEach((btn) => {
        const card =
          btn.closest(".rebuy-bundle-builder__step-product") ||
          btn.closest(".rebuy-product-block");
        const media = card && card.querySelector(".rebuy-product-media");
        if (media && btn.parentElement !== media) {
          media.appendChild(btn);
        }
      });
  }
 
  function init() {
    moveQuickViews();
 
    // Rebuy re-renders product blocks (variant/step changes); re-apply.
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        moveQuickViews();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
 
/* ------------------------------------------------------------------ */
/* Quick View modal: inject the product's description (Rebuy's modal    */
/* doesn't include one). We capture the product from the card that      */
/* launched the modal, fetch /products/{handle}.js, and show the lead   */
/* paragraph under the size selector (styled in rebuy-bundle.css).      */
/* ------------------------------------------------------------------ */
(() => {
  let pendingHandle = null;
  const cache = {};
 
  function handleFromCard(card) {
    if (!card) return null;
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
 
  function leadParagraph(html) {
    const t = document.createElement("div");
    t.innerHTML = html || "";
    const ps = [...t.querySelectorAll("p")]
      .map((p) => p.textContent.trim())
      .filter((x) => x.length > 20);
    return ps[0] || t.textContent.trim();
  }
 
  // remember which product's Quick View is being opened
  document.addEventListener(
    "click",
    (e) => {
      const btn =
        e.target.closest &&
        e.target.closest(".rebuy-bundle-builder__product-quick-view");
      if (!btn) return;
      const card =
        btn.closest(".rebuy-bundle-builder__step-product") ||
        btn.closest(".rebuy-product-block");
      pendingHandle = handleFromCard(card);
    },
    true
  );
 
  async function injectDescription() {
    const modal = document.querySelector(".rebuy-modal.is-visible");
    if (!modal || !pendingHandle) return;
    const info = modal.querySelector(".rebuy-modal__product-info");
    if (!info) return;
 
    let el = info.querySelector(".cc-qv-description");
    if (el && el.dataset.handle === pendingHandle) return; // already correct
    if (el) el.remove();
 
    // reserve synchronously so overlapping mutations don't duplicate it
    el = document.createElement("div");
    el.className = "cc-qv-description";
    el.dataset.handle = pendingHandle;
    info.appendChild(el);
 
    const handle = pendingHandle;
    let desc = cache[handle];
    if (desc === undefined) {
      try {
        const p = await fetch("/products/" + handle + ".js").then((r) => r.json());
        desc = leadParagraph(p && p.description);
      } catch (e) {
        desc = "";
      }
      cache[handle] = desc;
    }
    if (el.dataset.handle === handle) {
      el.textContent = desc;
      if (!desc) el.remove();
    }
  }
 
  const observer = new MutationObserver(() => {
    if (document.querySelector(".rebuy-modal.is-visible .rebuy-modal__product-info")) {
      injectDescription();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
})();
 
/* ------------------------------------------------------------------ */
/* Auto-advance: after a customer adds an item from the first step,     */
/* move them straight to step 2. Works for BOTH ways to add:            */
/*   (a) the "Add To Bundle" button on a product card, and              */
/*   (b) the "Add To Bundle" button inside the Quick View modal.        */
/* The modal isn't inside a step container, so that path keys off the   */
/* step currently on screen and waits for the set to actually grow      */
/* (so a failed add — e.g. no size chosen — never closes the modal).    */
/* ------------------------------------------------------------------ */
(() => {
  function tabActive(sel) {
    const t = document.querySelector(sel);
    return !!(t && t.classList.contains("active"));
  }
  function advance() {
    const nextTab = document.querySelector(
      ".rebuy-bundle-builder__step-tab-1"
    );
    if (nextTab && !nextTab.classList.contains("active")) nextTab.click();
  }
  function closeModal() {
    const m = document.querySelector(".rebuy-modal.is-visible");
    const x = m && m.querySelector(".rebuy-modal__close");
    if (x) x.click();
  }
 
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest && e.target.closest(".rebuy-button");
      if (!btn) return;
 
      // (a) "Add To Bundle" on a product card in the first step
      if (btn.closest(".rebuy-bundle-builder__product-quantity")) {
        if (btn.closest(".rebuy-bundle-builder__step-container-0")) {
          setTimeout(advance, 600);
        }
        return;
      }
 
      // (b) "Add To Bundle" inside the Quick View modal, while the first
      //     step is the one on screen
      const isModalAdd =
        btn.closest(".rebuy-modal") && /add/i.test(btn.textContent || "");
      if (isModalAdd && tabActive(".rebuy-bundle-builder__step-tab-0")) {
        // Wait for a valid first-step selection to register (step 2 unlocks),
        // then close the modal and advance. Guarding on the unlock — rather
        // than a rising item count — means a *replacement* still advances
        // (the first step is single-select, so its count stays at 1).
        let tries = 0;
        const iv = setInterval(() => {
          const step2 = document.querySelector(
            ".rebuy-bundle-builder__step-container-1"
          );
          if (step2 && !step2.classList.contains("locked")) {
            clearInterval(iv);
            closeModal();
            setTimeout(advance, 250);
          } else if (++tries >= 12) {
            clearInterval(iv); // nothing got selected — leave the modal open
          }
        }, 150);
      }
    },
    true
  );
})();
 
/* ------------------------------------------------------------------ */
/* Product-type sub-tabs on every bundle step (both bundles).          */
/* Adds a filter row (All + one tab per product type) above the active */
/* step's grid so shoppers can narrow by type. The type is the real    */
/* Shopify product type, read from /products/{handle}.js (.type) and    */
/* cached in sessionStorage. Only the active step is processed.        */
/* ------------------------------------------------------------------ */
(() => {
  const TYPE = {}; // handle -> product type
  const INFLIGHT = {};
  const selected = {}; // step key -> selected value
 
  // Tidy / group product-type labels. Types listed here are relabelled
  // (and several map to the same label, which merges them into one tab).
  // Anything not listed keeps its product type, with a leading "Bikini "
  // stripped (so future bikini types read cleanly too).
  const GROUPS = {
    "Bra": "Underwired Bra",
    "Brief": "Briefs",
    "Bikini Bandeau": "Bandeau",
    "Bikini Top": "Top",
    "Bikini Triangle": "Triangle",
    "Triangle Top": "Triangle",
    "Halter Swim": "Halterneck",
    "Halterneck Triangle": "Halterneck",
    "Bikini Bottom": "Briefs",
    "One size tanga": "Tanga",
    "Tanga Bikini": "Tanga",
    "Side Tie Bikini Briefs": "Side Tie Briefs",
    "Thong Bikini": "Thong",
  };
  function categoryOf(t) {
    if (!t) return "";
    if (GROUPS[t]) return GROUPS[t];
    return t.replace(/^Bikini\s+/i, "");
  }
 
  function handleOf(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
 
  function fetchType(h) {
    if (!h || h in TYPE || h in INFLIGHT) return;
    try {
      const s = sessionStorage.getItem("ccPT:" + h);
      if (s !== null) {
        TYPE[h] = s;
        return;
      }
    } catch (e) {}
    INFLIGHT[h] = fetch("/products/" + h + ".js", {
      credentials: "same-origin",
      priority: "low", // background hint so it never competes with page load
    })
      .then((r) => r.json())
      .then((p) => {
        TYPE[h] = (p.type || "").trim();
        try {
          sessionStorage.setItem("ccPT:" + h, TYPE[h]);
        } catch (e) {}
      })
      .catch(() => {
        TYPE[h] = "";
      })
      .then(() => {
        delete INFLIGHT[h];
        schedule();
      });
  }
 
  function stepKey(step) {
    return step.className.indexOf("__step-container-0") > -1 ? "0" : "1";
  }
 
  function applyFilter(step, key) {
    const sel = selected[key] || "__all";
    step.querySelectorAll(".rebuy-product-block").forEach((c) => {
      const t = c.getAttribute("data-cc-type") || "";
      c.style.display = sel === "__all" || t === sel ? "" : "none";
    });
  }
 
  function processStep(step) {
    const cards = [...step.querySelectorAll(".rebuy-product-block")];
    if (!cards.length) return;
    let allKnown = true;
    const present = [];
    cards.forEach((c) => {
      const h = handleOf(c);
      if (h && h in TYPE) {
        const t = categoryOf(TYPE[h]);
        c.setAttribute("data-cc-type", t);
        if (t && present.indexOf(t) < 0) present.push(t);
      } else {
        allKnown = false;
        fetchType(h);
      }
    });
    if (!allKnown) return; // wait until every card's type is resolved
    if (present.length < 2) return; // nothing to split
    present.sort();
    const key = stepKey(step);
    if (!(key in selected)) selected[key] = "__all";
    const wanted = ["__all"].concat(present).join("|");
    let bar = step.querySelector(":scope > .cc-subtabs");
    if (bar && bar.getAttribute("data-cc-set") === wanted) {
      applyFilter(step, key);
      return;
    }
    if (bar) bar.remove();
    bar = document.createElement("div");
    bar.className = "cc-subtabs";
    bar.setAttribute("data-cc-set", wanted);
    bar.setAttribute("role", "group");
    bar.setAttribute("aria-label", "Filter products by type");
    const mk = (label, val) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "cc-subtab" + (selected[key] === val ? " active" : "");
      b.textContent = label;
      b.setAttribute("data-val", val);
      b.setAttribute("aria-pressed", selected[key] === val ? "true" : "false");
      return b;
    };
    bar.appendChild(mk("All", "__all"));
    present.forEach((t) => bar.appendChild(mk(t, t)));
    bar.addEventListener("click", (e) => {
      const btn = e.target.closest && e.target.closest(".cc-subtab");
      if (!btn) return;
      selected[key] = btn.getAttribute("data-val");
      bar.querySelectorAll(".cc-subtab").forEach((x) => {
        const on = x === btn;
        x.classList.toggle("active", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      applyFilter(step, key);
    });
    // direct child of the step container, above the grid, so it survives
    // Rebuy re-rendering the grid inside
    step.insertBefore(bar, step.firstChild);
    applyFilter(step, key);
  }
 
  // Keep the sticky "Your Set" rail starting level with the first product
  // card. Because the stepper + this sub-tab nav sit above the grid, a fixed
  // offset drifts; measuring the real gap self-corrects.
  function alignRail() {
    const rail = document.querySelector(
      ".rebuy-bundle-builder__group-container"
    );
    if (!rail) return;
    // desktop side-rail only; on mobile the rail is a bottom dock
    if (!window.matchMedia("(min-width: 1180px)").matches) {
      rail.style.removeProperty("margin-top");
      return;
    }
    const mb = document.querySelector(".rebuy-bundle-builder__main-body");
    const card = document.querySelector(
      ".rebuy-bundle-builder__step-container--active .rebuy-product-block"
    );
    if (!mb || !card) return;
    // both are in normal flow, so this delta is scroll-independent
    const offset = Math.round(
      card.getBoundingClientRect().top - mb.getBoundingClientRect().top
    );
    if (offset > 0 && offset < 600) {
      rail.style.setProperty("margin-top", offset + "px", "important");
    }
  }
 
  // Publish the sticky stepper's height so the sub-tab nav can stick just
  // beneath it (CSS reads --cc-stepper-h). Height is breakpoint-dependent,
  // not scroll-dependent, so this only needs to run on layout changes.
  function syncStepperHeight() {
    const st = document.querySelector(
      ".rebuy-bundle-builder__step-tabs--sticky, .rebuy-bundle-builder__step-tabs"
    );
    if (st && st.offsetHeight) {
      document.documentElement.style.setProperty(
        "--cc-stepper-h",
        st.offsetHeight + "px"
      );
    }
  }
 
  function run() {
    const active = document.querySelector(
      ".rebuy-bundle-builder__step-container--active"
    );
    if (active) processStep(active);
    alignRail();
    syncStepperHeight();
  }
 
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
  window.addEventListener("resize", schedule);
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", run);
  else run();
})();
 
/* ------------------------------------------------------------------ */
/* Show Rebuy's "Top" scroll button only after scrolling down.         */
/* ------------------------------------------------------------------ */
(() => {
  function onScroll() {
    document.body.classList.toggle("cc-scrolled", window.scrollY > 400);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();
 
/* ------------------------------------------------------------------ */
/* Mobile: tapping the product image opens Quick View (the separate    */
/* Quick View button is hidden on touch via CSS). Keeps shoppers in    */
/* the bundle flow rather than navigating away to the product page.    */
/* ------------------------------------------------------------------ */
(() => {
  document.addEventListener(
    "click",
    (e) => {
      // desktop keeps its normal behaviour (image link + hover Quick View)
      if (window.matchMedia("(hover: hover)").matches) return;
      const img =
        e.target.closest &&
        e.target.closest(".rebuy-product-media a.rebuy-product-image");
      if (!img) return;
      const card =
        img.closest(".rebuy-bundle-builder__step-product") ||
        img.closest(".rebuy-product-block");
      const qv =
        card && card.querySelector(".rebuy-bundle-builder__product-quick-view");
      if (qv) {
        e.preventDefault();
        e.stopPropagation();
        qv.click();
      }
    },
    true
  );
})();
 
/* ------------------------------------------------------------------ */
/* Quick View modal: replace the native size <select> with square      */
/* size buttons (matches the PDP reference). The buttons drive the      */
/* underlying select so Rebuy's add-to-cart keeps working unchanged.    */
/* ------------------------------------------------------------------ */
(() => {
  const SIZE_BTNS = "cc-size-btns";
 
  function labelFor(opt) {
    // option text is "Size / Color" (e.g. "M / Black") -> take the size
    const t = (opt.textContent || "").split("/")[0].trim();
    return t || (opt.textContent || "").trim();
  }
 
  function syncActive(wrap, select) {
    const val = select.value;
    wrap.querySelectorAll(".cc-size-btn").forEach((b) => {
      const on = b.dataset.value === val;
      b.classList.toggle("active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
 
  function build(select) {
    const field = select.closest(".rebuy-modal__product-option-select");
    if (!field) return;
    // rebuild if the option set changed (different product opened)
    const sig = Array.from(select.options)
      .map((o) => o.value + ":" + o.disabled)
      .join("|");
    const existing = field.querySelector("." + SIZE_BTNS);
    if (existing && existing.dataset.sig === sig) {
      syncActive(existing, select);
      return;
    }
    if (existing) existing.remove();
 
    const wrap = document.createElement("div");
    wrap.className = SIZE_BTNS;
    wrap.dataset.sig = sig;
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "Size");
 
    Array.from(select.options).forEach((opt) => {
      if (!opt.value) return; // skip any placeholder option
      const b = document.createElement("button");
      b.type = "button";
      b.className = "cc-size-btn";
      b.dataset.value = opt.value;
      b.textContent = labelFor(opt);
      if (opt.disabled) {
        b.setAttribute("aria-disabled", "true");
      } else {
        b.addEventListener("click", () => {
          select.value = opt.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          syncActive(wrap, select);
        });
      }
      wrap.appendChild(b);
    });
 
    select.insertAdjacentElement("afterend", wrap);
    // keep buttons in sync if Rebuy changes the select programmatically
    select.addEventListener("change", () => syncActive(wrap, select));
    syncActive(wrap, select);
  }
 
  function scan() {
    document
      .querySelectorAll(
        ".rebuy-modal.is-visible .rebuy-modal__product-option-select select.rebuy-select"
      )
      .forEach(build);
  }
 
  let raf = 0;
  const debounced = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      scan();
    });
  };
 
  new MutationObserver(debounced).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
  scan();
})();
 
/* ------------------------------------------------------------------ */
/* Mobile: make the whole "Your Set" summary bar a tap target to        */
/* expand/collapse it, not just the little chevron. Forwards taps on    */
/* the header to Rebuy's own expand button (which keeps its own click).  */
/* ------------------------------------------------------------------ */
(() => {
  document.addEventListener(
    "click",
    (e) => {
      if (!window.matchMedia("(max-width: 1179px)").matches) return;
      const header =
        e.target.closest &&
        e.target.closest(".rebuy-bundle-builder__group-container-header");
      if (!header) return;
      // the real toggle already handles its own taps — don't double-fire
      if (
        e.target.closest(
          ".rebuy-bundle-builder__group-container-header-expand"
        )
      )
        return;
      const btn = header.querySelector(
        ".rebuy-bundle-builder__group-container-header-expand"
      );
      if (btn) btn.click();
    },
    false
  );
})();